//HERPreviewModal.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";
import {
  Close as CloseIcon,
  DownloadForOfflineSharp,
  OpenInNew
} from "@mui/icons-material";

const HERPreviewModal = ({
  open,
  onClose,
  content,
  notification,
  notificationsPerPage,
  focusIndex,
  changePreviewNotification,
  totalNotifications,
}) => {

  const getNotificationBody = () => {
    // Debug logging to understand the content structure
    console.log("HER Preview Content:", content);
    const notificationBody = content?.payload?.notificationBody || content?.notificationBody;
    console.log("Notification Body URL:", notificationBody);
    return notificationBody;
  };

  const handleDownload = () => {
    const notificationBody = getNotificationBody();
    if (notificationBody) {
      // Open the PDF URL in a new tab for download
      window.open(notificationBody, '_blank');
    }
  };

  const handleOpenInNewTab = () => {
    const notificationBody = getNotificationBody();
    if (notificationBody) {
      window.open(notificationBody, '_blank');
    }
  };

  const isPdfUrl = (url) => {
    return url && (url.toLowerCase().includes('.pdf') || url.toLowerCase().includes('pdf'));
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="lg"
      fullWidth
      PaperProps={{ 
        style: { 
          height: '90vh',
          maxHeight: '90vh'
        } 
      }}
    >
      <DialogTitle style={{ fontWeight: 'bold', position: 'relative', background: 'white', zIndex: 1 }}>
        <Typography variant="h6" component="div">
          HER Preview
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Destination: <span>{notification?.deliveryDestination}</span>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Title: {notification?.notificationTitle}
        </Typography>
        
        <div style={{ position: 'absolute', right: 8, top: 8 }}>
          <Button 
            onClick={() => changePreviewNotification(focusIndex - 1)} 
            color="primary" 
            title="Previous HER" 
            disabled={focusIndex <= 0}
            size="small"
          >
            Previous
          </Button>
          <Button 
            onClick={() => changePreviewNotification(focusIndex + 1)} 
            color="primary" 
            title="Next HER" 
            disabled={focusIndex === notificationsPerPage - 1 || focusIndex === totalNotifications - 1}
            size="small"
          >
            Next
          </Button>
          <Button 
            onClick={handleOpenInNewTab} 
            color="primary" 
            title="Open in New Tab"
            size="small"
            startIcon={<OpenInNew />}
          >
            Open
          </Button>
          <Button 
            onClick={handleDownload} 
            color="primary" 
            title="Download HER"
            size="small"
          >
            <DownloadForOfflineSharp /> 
          </Button>
          <Button onClick={onClose} color="inherit" size="small">
            <CloseIcon />
          </Button>
        </div>
      </DialogTitle>
      
      <DialogContent style={{ padding: 0, height: '100%' }}>
        {!content ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="400px">
            <CircularProgress />
          </Box>
        ) : !getNotificationBody() ? (
          <Alert severity="error" sx={{ m: 2 }}>
            No HER content available for this notification.
          </Alert>
        ) : isPdfUrl(getNotificationBody()) ? (
          <Box sx={{ height: '100%', width: '100%' }}>
            <iframe
              src={getNotificationBody()}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                minHeight: '600px'
              }}
              title="HER Preview"
              onError={() => {
                console.error("Failed to load PDF in iframe");
              }}
            />
          </Box>
        ) : (
          <Box sx={{ p: 2 }}>
            <Alert severity="info" sx={{ mb: 2 }}>
              This HER content is not a PDF or cannot be displayed inline.
            </Alert>
            <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
              Content URL: {getNotificationBody()}
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Button
                variant="contained"
                onClick={handleOpenInNewTab}
                startIcon={<OpenInNew />}
              >
                Open Content in New Tab
              </Button>
            </Box>
          </Box>
        )}
      </DialogContent>
      
      <DialogActions>
        {/* Additional actions can be added here if needed */}
      </DialogActions>
    </Dialog>
  );
};

export default HERPreviewModal;
